module.exports = __webpack_public_path__ + "assets/zcash.a99f9413.png";